export default {
  'offset-1': 700,
  'offset-2': 600,
  'offset-3': 500,
};
